"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitingFor = void 0;
const vue_1 = require("vue");
const AndOptions_1 = require("./AndOptions");
const OrOptions_1 = require("./OrOptions");
const PlayerInputFactory_1 = require("./PlayerInputFactory");
const SelectAmount_1 = require("./SelectAmount");
const SelectCard_1 = require("./SelectCard");
const SelectHowToPay_1 = require("./SelectHowToPay");
const SelectHowToPayForProjectCard_1 = require("./SelectHowToPayForProjectCard");
const SelectInitialCards_1 = require("./SelectInitialCards");
const SelectOption_1 = require("./SelectOption");
const SelectPlayer_1 = require("./SelectPlayer");
const SelectSpace_1 = require("./SelectSpace");
const i18n_1 = require("../directives/i18n");
const SelectPartyPlayer_1 = require("./SelectPartyPlayer");
const SelectPartyToSendDelegate_1 = require("./SelectPartyToSendDelegate");
const PreferencesManager_1 = require("./PreferencesManager");
const SoundManager_1 = require("./SoundManager");
const SelectColony_1 = require("./SelectColony");
const SelectProductionToLose_1 = require("./SelectProductionToLose");
const ShiftAresGlobalParameters_1 = require("./ShiftAresGlobalParameters");
const Phase_1 = require("../Phase");
const constants = require("../constants");
let ui_update_timeout_id;
let documentTitleTimer;
exports.WaitingFor = vue_1.default.component('waiting-for', {
    props: {
        player: {
            type: Object,
        },
        players: {
            type: Array,
        },
        settings: {
            type: Object,
        },
        waitingfor: {
            type: Object,
        },
    },
    data: function () {
        return {
            waitingForTimeout: this.settings.waitingForTimeout,
        };
    },
    components: {
        'and-options': AndOptions_1.AndOptions,
        'or-options': OrOptions_1.OrOptions,
        'select-amount': SelectAmount_1.SelectAmount,
        'select-card': SelectCard_1.SelectCard,
        'select-option': SelectOption_1.SelectOption,
        'select-how-to-pay': SelectHowToPay_1.SelectHowToPay,
        'select-how-to-pay-for-project-card': SelectHowToPayForProjectCard_1.SelectHowToPayForProjectCard,
        'select-initial-cards': SelectInitialCards_1.SelectInitialCards,
        'select-player': SelectPlayer_1.SelectPlayer,
        'select-space': SelectSpace_1.SelectSpace,
        'select-party-player': SelectPartyPlayer_1.SelectPartyPlayer,
        'select-party-to-send-delegate': SelectPartyToSendDelegate_1.SelectPartyToSendDelegate,
        'select-colony': SelectColony_1.SelectColony,
        'select-production-to-lose': SelectProductionToLose_1.SelectProductionToLose,
        'shift-ares-global-parameters': ShiftAresGlobalParameters_1.ShiftAresGlobalParameters,
    },
    methods: {
        updatePlayersOverview: function () {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', '/api/player' + window.location.search.replace('&noredirect', ''));
            xhr.onerror = function () {
                alert('Error getting game data');
            };
            xhr.onload = () => {
                if (xhr.status === 200) {
                    const player = this.$root.player;
                    const draftedPlayers = xhr.response.draftedPlayers;
                    const researchedPlayers = xhr.response.researchedPlayers;
                    if (player !== undefined && player.draftedPlayers.length !== draftedPlayers.length) {
                        player.draftedPlayers = draftedPlayers;
                        this.$root.$emit('updatePlayersOverview');
                    }
                    else if (player !== undefined && player.researchedPlayers.length !== researchedPlayers.length) {
                        player.researchedPlayers = researchedPlayers;
                        this.$root.$emit('updatePlayersOverview');
                    }
                }
            };
            xhr.responseType = 'json';
            xhr.send();
        },
        animateTitle: function () {
            const sequence = '\u25D1\u25D2\u25D0\u25D3';
            const first = document.title[0];
            const position = sequence.indexOf(first);
            let next = sequence[0];
            if (position !== -1 && position < sequence.length - 1) {
                next = sequence[position + 1];
            }
            document.title = next + ' ' + i18n_1.$t(constants.APP_NAME);
        },
        waitForUpdate: function () {
            const vueApp = this;
            const root = this.$root;
            clearTimeout(ui_update_timeout_id);
            const askForUpdate = () => {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', '/api/waitingfor' + window.location.search + '&gameAge=' + this.player.gameAge + '&undoCount=' + this.player.undoCount);
                xhr.onerror = function () {
                    root.showAlert('Unable to reach the server. The server may be restarting or down for maintenance.', () => vueApp.waitForUpdate());
                };
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        const result = xhr.response;
                        const player = this.$root.player;
                        if (result.result === 'GO') {
                            root.updatePlayer();
                            if (Notification.permission !== 'granted') {
                                Notification.requestPermission();
                            }
                            else if (Notification.permission === 'granted') {
                                new Notification(constants.APP_NAME, {
                                    icon: '/favicon.ico',
                                    body: 'It\'s your turn!',
                                });
                            }
                            const soundsEnabled = PreferencesManager_1.PreferencesManager.load('enable_sounds') === '1';
                            if (soundsEnabled)
                                SoundManager_1.SoundManager.playActivePlayerSound();
                            return;
                        }
                        else if (result.result === 'REFRESH') {
                            root.updatePlayer();
                            return;
                        }
                        else if (player !== undefined && (player.phase === Phase_1.Phase.DRAFTING || player.phase === Phase_1.Phase.RESEARCH)) {
                            this.updatePlayersOverview();
                        }
                        vueApp.waitForUpdate();
                    }
                    else {
                        root.showAlert(`Received unexpected response from server (${xhr.status}). This is often due to the server restarting.`, () => vueApp.waitForUpdate());
                    }
                };
                xhr.responseType = 'json';
                xhr.send();
            };
            ui_update_timeout_id = window.setTimeout(askForUpdate, this.waitingForTimeout);
        },
        checkDraftAndResearchStatus: function () {
            clearTimeout(ui_update_timeout_id);
            const checkDrafters = () => {
                this.updatePlayersOverview();
                ui_update_timeout_id = window.setTimeout(checkDrafters, this.waitingForTimeout);
            };
            ui_update_timeout_id = window.setTimeout(checkDrafters, this.waitingForTimeout);
        },
    },
    render: function (createElement) {
        document.title = i18n_1.$t(constants.APP_NAME);
        window.clearInterval(documentTitleTimer);
        if (this.waitingfor === undefined) {
            this.waitForUpdate();
            return createElement('div', i18n_1.$t('Not your turn to take any actions'));
        }
        if (this.player.phase === Phase_1.Phase.DRAFTING || this.player.phase === Phase_1.Phase.RESEARCH) {
            this.checkDraftAndResearchStatus();
        }
        if (this.player.players.length > 1 && this.player.waitingFor !== undefined) {
            documentTitleTimer = window.setInterval(() => this.animateTitle(), 1000);
        }
        const input = new PlayerInputFactory_1.PlayerInputFactory().getPlayerInput(createElement, this.players, this.player, this.waitingfor, (out) => {
            const xhr = new XMLHttpRequest();
            const root = this.$root;
            const showAlert = this.$root.showAlert;
            if (root.isServerSideRequestInProgress) {
                console.warn('Server request in progress');
                return;
            }
            root.isServerSideRequestInProgress = true;
            xhr.open('POST', '/player/input?id=' + this.player.id);
            xhr.responseType = 'json';
            xhr.onload = () => {
                if (xhr.status === 200) {
                    root.screen = 'empty';
                    root.player = xhr.response;
                    root.playerkey++;
                    root.screen = 'player-home';
                    if (this.player.phase === 'end' && window.location.pathname !== '/the-end') {
                        (window).location = (window).location;
                    }
                }
                else if (xhr.status === 400 && xhr.responseType === 'json') {
                    showAlert(xhr.response.message);
                }
                else {
                    showAlert('Unexpected response from server. Please try again.');
                }
                root.isServerSideRequestInProgress = false;
            };
            xhr.send(JSON.stringify(out));
            xhr.onerror = function () {
                root.isServerSideRequestInProgress = false;
            };
        }, true, true);
        return createElement('div', { 'class': 'wf-root' }, [input]);
    },
});
//# sourceMappingURL=WaitingFor.js.map